<template>
    <div class="visual-menu">
        <slot name="default"></slot>
    </div>
</template>

<script>
    export default {
        props: {
            color: {type: String, default: '#fff'}
        }
    }
</script>

<style lang="scss">
    .visual-menu {
        display: flex;
    }
</style>